import $ from 'jquery';

export default class DownloadPortal {
	init() {
		$('[data-download-portal]').each((_, element) => {
			this.initializePortal($(element));
		});
	}

	initializePortal(portal) {
		const initialView = portal.data('initial-view') || 'list';
		const contentElementUid = this.resolveContentElementUid(portal);
		portal.data('content-element-uid', contentElementUid);

		this.applyView(portal, initialView);
		this.initializeWhitepaperModal(portal);

		portal.find('[data-download-portal-view]').on('click', (event) => {
			const button = $(event.currentTarget);
			this.applyView(portal, button.data('download-portal-view'));
		});

		this.initializeCategorySelect(portal);
	}

	applyView(portal, view) {
		const normalizedView = view === 'tiles' ? 'tiles' : 'list';
		portal.removeClass('download-portal--list download-portal--tiles');
		portal.addClass(`download-portal--${normalizedView}`);

		portal.find('[data-download-portal-view]').removeClass('is-active');
		portal
			.find(`[data-download-portal-view="${normalizedView}"]`)
			.addClass('is-active');
	}

	initializeWhitepaperModal(portal) {
		const modal = portal.find('[data-download-portal-modal]');
		if (modal.length === 0) {
			return;
		}

		portal.find('[data-requires-lead-form="1"]').on('click', (event) => {
			event.preventDefault();
			const link = $(event.currentTarget);
			this.openWhitepaperModal(portal, modal, link);
		});

		modal.find('[data-download-portal-modal-close]').on('click', () => {
			this.closeWhitepaperModal(modal);
		});

		modal.find('[data-download-portal-modal-form]').on('submit', async (event) => {
			event.preventDefault();
			await this.submitWhitepaperForm(portal, modal, $(event.currentTarget));
		});
	}

	openWhitepaperModal(portal, modal, link) {
		this.resetWhitepaperModal(modal);
		modal.find('[data-download-portal-modal-file-title]').text(link.data('file-title'));
		modal.find('[data-download-portal-modal-file-input]').val(link.data('file-uid'));
		modal.find('[name="contentElement"]').val(portal.data('content-element-uid') || '');
		modal.data('download-url', link.data('file-url'));
		modal.prop('hidden', false);
		$('body').addClass('download-portal-modal-open');
	}

	closeWhitepaperModal(modal) {
		modal.prop('hidden', true);
		$('body').removeClass('download-portal-modal-open');
	}

	resetWhitepaperModal(modal) {
		modal.find('[data-download-portal-modal-form-state]').prop('hidden', false);
		modal.find('[data-download-portal-modal-success-state]').prop('hidden', true);
		modal.find('[data-download-portal-modal-form]').trigger('reset');
		modal.find('[data-download-portal-modal-error]').text('');
		modal.find('[data-download-portal-error]').text('');
	}

	async submitWhitepaperForm(portal, modal, form) {
		const endpoint = portal.data('whitepaper-request-uri');
		const payload = form.serialize();
		const errorBox = modal.find('[data-download-portal-modal-error]');
		errorBox.text('');
		modal.find('[data-download-portal-error]').text('');

		try {
			const response = await fetch(endpoint, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
					'X-Requested-With': 'XMLHttpRequest',
				},
				body: payload,
			});
			const responseText = await response.text();
			let data = null;

			try {
				data = JSON.parse(responseText);
			} catch (parseError) {
				errorBox.text('Die Anfrage konnte nicht verarbeitet werden.');
				return;
			}

			if (!response.ok || !data.success) {
				if (data.errors) {
					Object.entries(data.errors).forEach(([field, message]) => {
						modal.find(`[data-download-portal-error="${field}"]`).text(String(message));
					});
				}
				if (data.errors?.file || data.errors?.recipients) {
					errorBox.text(String(data.errors.file || data.errors.recipients));
				}
				return;
			}

			modal.find('[data-download-portal-modal-form-state]').prop('hidden', true);
			modal.find('[data-download-portal-modal-success-state]').prop('hidden', false);
			modal.find('[data-download-portal-modal-success-message]').text(data.message);
			modal.find('[data-download-portal-modal-download-link]')
				.attr('href', data.downloadUrl)
				.attr('download', '')
				.text(`${data.fileTitle} herunterladen`);

			this.triggerDownload(data.downloadUrl);
		} catch (error) {
			errorBox.text('Der Download konnte gerade nicht freigegeben werden.');
		}
	}

	triggerDownload(url) {
		const link = document.createElement('a');
		link.href = url;
		link.setAttribute('download', '');
		link.target = '_blank';
		document.body.appendChild(link);
		link.click();
		link.remove();
	}

	resolveContentElementUid(portal) {
		const contentElement = portal.closest('[id^="c"]');
		if (contentElement.length === 0) {
			return '';
		}

		const id = String(contentElement.attr('id') || '');
		return id.startsWith('c') ? id.slice(1) : '';
	}

	initializeCategorySelect(portal) {
		const hiddenField = portal.find('[data-download-portal-categories-hidden]');
		const selectField = portal.find('[data-download-portal-category-select]');
		const tagCloud = portal.find('[data-download-portal-tag-cloud]');
		if (hiddenField.length === 0 || selectField.length === 0 || tagCloud.length === 0) {
			return;
		}

		const getValues = () => {
			const value = String(hiddenField.val() || '');
			if (!value) {
				return [];
			}

			return value.split(',').map((entry) => entry.trim()).filter(Boolean);
		};

		const setValues = (values) => {
			hiddenField.val(values.join(','));
		};

		const getLabel = (value) => {
			const option = selectField.find(`option[value="${value}"]`);
			return option.length ? option.text() : value;
		};

		const createTag = (value, label) => {
			const tag = $(`
				<span class="tag tag--filter tag--location" data-download-portal-tag data-value="${value}">
					<span class="tag__label"></span>
					<button class="tag__remove" type="button" aria-label="${label} entfernen">&times;</button>
				</span>
			`);

			tag.find('.tag__label').text(label);
			return tag;
		};

		const renderTags = () => {
			tagCloud.empty();

			getValues().forEach((value) => {
				tagCloud.append(createTag(value, getLabel(value)));
			});
		};

		selectField.on('change', () => {
			const selectedValue = String(selectField.val() || '');
			if (!selectedValue) {
				return;
			}

			const values = getValues();
			if (!values.includes(selectedValue)) {
				values.push(selectedValue);
				setValues(values);
				renderTags();
			}
			selectField.val('');
		});

		tagCloud.on('click', '.tag__remove', (event) => {
			const tag = $(event.currentTarget).closest('[data-download-portal-tag]');
			const value = String(tag.data('value'));
			const values = getValues().filter((entry) => entry !== value);
			setValues(values);
			renderTags();
		});

		renderTags();
	}
}
